import React, { useEffect, useState } from "react";
import { HiMenuAlt3, HiMenuAlt1 } from "react-icons/hi";
import { RiMenuLine } from "react-icons/ri";
import { HiOutlineX } from "react-icons/hi";
import { FaCaretDown } from "react-icons/fa";
import ResponsiveMenu from "./ResponsiveMenu";
import { FaMoneyBillWave } from "react-icons/fa";
import { socket } from "../../api";
import { parseJWT } from "../../utils/jwtUtils";
import { useTranslation } from "react-i18next";
import Logo from "../../assets/game-logo-removebg-preview.png";
import { Link } from "react-router-dom";
import { FaWallet, FaEye, FaEyeSlash } from "react-icons/fa";

const Navbar2 = () => {
  const [showMenu, setShowMenu] = useState(false);
  const [balance, setBalance] = useState(0);
  const [showBalance, setShowBalance] = useState(true);

  const toggleMenu = () => {
    setShowMenu(!showMenu);
  };

  const handleLogout = (e) => {
    e.preventDefault(); // prevent default link navigation
    localStorage.removeItem("userInfo"); // remove user info if stored
    window.location.href = "/login"; // redirect to login page
  };
  const token = localStorage.getItem("userInfo")
    ? JSON.parse(localStorage.getItem("userInfo"))
    : null;
  const userInfo = parseJWT(token?.token);

  useEffect(() => {
    if (userInfo?.phone) {
      //   console.log("Requesting balance for phone:", userInfo.phone);
      socket.emit("getBalance", { phone: userInfo.phone });

      socket.on("balanceResponse", (data) => {
        //  console.log("Received balance response from server:", data);
        if (data.success) {
          setBalance(data.balance);
        }
      });
    }

    return () => {
      socket.off("balanceResponse");
    };
  }, [userInfo?.phone]);

  const { t: translate, i18n } = useTranslation(["header"]);

  return (
    <>
      <div
        data-aos="fade"
        data-aos-duration="300"
        className="relative z-[50] border-b-[1px]  border-primary/50 bg-gradient-to-l from-[#273E60] via-[#375B82]  to-[#273E60] text-white shadow-lg"
      >
        <header data-aos="fade" data-aos-duration="300" className="">
          <nav className="container  flex h-[70px] items-center justify-between py-1">
            <div className="text-2xl text-white md:text-3xl font-serif">
              <a
                href="/"
                className="text-xl font-extrabold tracking-wide 
             bg-gradient-to-r from-cyan-300 via-emerald-400 to-orange-400 
             bg-clip-text text-transparent 
             hover:opacity-90 transition-opacity font-serif"
              >
                {/* {translate("zemed")} */}
                <img src={Logo} className="w-20" />
              </a>
            </div>
            {/* Desktop Menu */}
            <div className="hidden md:block">
              <ul className="flex items-center gap-10 font-serif">
                <li className="cursor pointer">
                  <a href="/">{translate("home")}</a>
                </li>
                <li className="cursor pointer">
                  <a href="/HowToPlay"> {translate("How_Play")}</a>
                </li>
                <li className="cursor pointer">
                  <a href="/referralIncome">{translate("Referral_Income")}</a>
                </li>
                <li className="cursor pointer">
                  <a href="https://t.me/enatgames">{translate("Contact_Us")}</a>
                </li>
                {/* Phone number section */}
                <div className="flex items-center gap-4">
                  <li>
                    <FaMoneyBillWave className="h-[40px] w-[40px] rounded-md bg-primary p-2 text-2xl text-white hover:bg-primary/90" />
                  </li>
                  <li>
                    <div>
                      <p className="text-sm">{translate("ETB")}</p>
                      <p className="text-lg">
                        {" "}
                        <a href="/wallet">{balance}</a>
                      </p>
                    </div>
                  </li>
                </div>

                <li className="group relative cursor-pointer">
                  <a href="/" className="flex h-[72px] items-center gap-[2px]">
                    {userInfo?.username}
                    <span>
                      <FaCaretDown className="transition-all duration-200 group-hover:rotate-180" />
                    </span>
                  </a>
                  <div className="absolute -left-9 z-[9999] hidden w-[150px] rounded-md bg-white p-2 text-black group-hover:block  ">
                    <ul className="space-y-3">
                      <li>
                        <a
                          href="/wallet"
                          className="p-2 hover:bg-violet-200 block"
                        >
                          {translate("Wallet")}
                        </a>
                      </li>
                      <li>
                        <a
                          href="/profile"
                          className="p-2 hover:bg-violet-200 block"
                        >
                          {translate("Profile")}
                        </a>
                      </li>
                      <li>
                        <a
                          href="/history"
                          className="p-2 hover:bg-violet-200 block"
                        >
                          {translate("Game_History")}
                        </a>
                      </li>
                      <li></li>
                      <li>
                        <a
                          onClick={handleLogout}
                          className="p-2 hover:bg-violet-200 block"
                        >
                          {translate("Log_out")}
                        </a>
                      </li>
                    </ul>
                  </div>
                </li>
              </ul>
            </div>

            {/* Mobile view  */}
            <div className="flex items-center gap-4 md:hidden ">
              <div className="flex items-center gap-4">
                <Link
                  to="/wallet"
                  className="
      inline-flex items-center gap-3
      px-4 py-2
      rounded-full
      border border-primary/50
      bg-gradient-to-l from-[#273E60] via-[#375B82] to-[#273E60]
      text-white font-semibold text-sm
      shadow-lg
      hover:shadow-xl hover:scale-105
      transition-all duration-200
      active:scale-95
    "
                >
                  <FaWallet className="text-green-200 text-sm" />

                  {/* Balance */}
                  <span className="text-sm tracking-wide">
                    {showBalance ? "••••••" : `${balance} ${translate("ETB")}`}
                  </span>

                  {/* Toggle Icon */}
                  <span
                    onClick={(e) => {
                      e.preventDefault(); // prevent link navigation
                      setShowBalance(!showBalance);
                    }}
                    className="text-gray-300 hover:text-white transition cursor-pointer"
                  >
                    {showBalance ? (
                      <FaEyeSlash className="text-lg" />
                    ) : (
                      <FaEye className="text-lg" />
                    )}
                  </span>
                </Link>
              </div>

              {showMenu ? (
                <HiOutlineX
                  onClick={toggleMenu}
                  className=" cursor-pointer transition-all"
                  size={30}
                />
              ) : (
                <RiMenuLine
                  onClick={toggleMenu}
                  className="cursor-pointer transition-all"
                  size={30}
                />
              )}
            </div>
          </nav>
        </header>
      </div>
      <ResponsiveMenu showMenu={showMenu} />
    </>
  );
};

export default Navbar2;
